import { z } from 'zod';

export const TrelloCardEvidenceSchema = z.object({
  id: z.string().min(1), cardId: z.string().regex(/^[0-9a-f]{24}$/), title: z.string(), status: z.string(),
  boardId: z.string().regex(/^[0-9a-f]{24}$/), boardName: z.string(),
  memberIds: z.array(z.string().regex(/^[0-9a-f]{24}$/)), archived: z.boolean(),
  collectedAt: z.string().datetime({ offset: true }), content: z.string(),
  externalUrl: z.string().regex(/^https:\/\/trello\.com\/c\/[a-zA-Z0-9]+$/),
});
export type TrelloCardEvidence = z.infer<typeof TrelloCardEvidenceSchema>;
